import {airportCodeMap} from "@/config/airportCodeMap"
import {trainStationCodeMap} from "@/config/trainStationCodeMap"

import availableFlightPackCodes from "@/vue/planning/computed/availableFlightPackCodes"
import { getCookie } from "@/utils/utils";

export default {
    bookingProcessURL: (state, getters) => {
        const beginDateParts = state.dates["BeginDate"] && state.dates["BeginDate"].split("/")
        const endDateParts = state.dates["EndDate"] && state.dates["EndDate"].split("/")

        const liheId = getters.selectedPrestations[0].prestation.fusionId || state.liheData.id;
        const participants = state.participants.join("-");
        const start_date = beginDateParts ? `${beginDateParts[2]}-${beginDateParts[1]}-${beginDateParts[0]}` : "";
        const end_date = endDateParts ? `${endDateParts[2]}-${endDateParts[1]}-${endDateParts[0]}` : "";
        const prestId = getters.selectedPrestations[0].prestation.prestId
        const prestations = getters.selectedPrestations && getters.selectedPrestations.map((prest)=>{
            return `${prest.prestation.prestIdSource}-${prest.quantity}-${prest.prestation.maxCapacity}`
        }).filter(_=>_).join('--');
        const season = global.seasonManager.season ? global.seasonManager.season : "";



        const pagePath = getBookingPocessPath(state, getters.locale)

        let baseUrl = `/booking/${pagePath}?lihe_id=${liheId}&participants=${participants}&start_date=${start_date}&end_date=${end_date}&prestations=${prestations}&season=${season}&prest_id=${prestId}`

        // Add the origin to the url
        if(state.flightOrigin && availableFlightPackCodes.value.find(packObj => packObj.codePackage === state.packCode)) {
            baseUrl += `&origin=${state.flightOrigin.split("-")[0]}`
        }

        return baseUrl 
    }
}


function getBookingPocessPath(state, locale) {
    const flightLocale = locale.replace("-", "_") === 'en_US'

    if(!state.transportationSelected || !flightLocale) return "options"

    // If we have multiplke origins we concat with -
    const flightOrigin = state.flightOrigin?.split("-")[0]
    // Decide the path based on selected origin
    if(airportCodeMap.get(flightOrigin)) {
        return 'flight'
    }else if(trainStationCodeMap.get(flightOrigin)) {
       return "train"
    }
    return "options";
}